import { ImgHTMLAttributes } from 'react';

import { m, MotionProps } from 'framer-motion';
import { GatsbyImage } from "gatsby-plugin-image"

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & MotionProps;

const Image = ({ ...options }: ImageProps) => (
  <m.img
    initial={{ y: '50%' }}
    whileInView={{ y: 0, transition: { duration: 1, ease: [0.5, 0.06, 0.01, 0.99] } }}
    onViewportLeave={(e) => console.log({e, options})}
    viewport={{ once: true }}
    loading="lazy"
    {...options} />
)

export default Image;

export const ImageGatsby = ({ image, alt, width = 'inherit', initialY = '50%', ...options }) => (
  <m.div
    initial={{ y: initialY }}
    whileInView={{ y: 0, transition: { duration: 1, ease: [0.5, 0.06, 0.01, 0.99] } }}
    viewport={{ once: true }}
    style={{ width }}
  >
    <GatsbyImage image={image} alt={alt} {...options} />
  </m.div>
);
